const defaultSortOptions = [
  {
    key: 'date',
    value: 'newest',
    label: {
      en: 'Latest',
      id: 'Terbaru'
    }
  },
  {
    key: 'date',
    value: 'oldest',
    label: {
      en: 'Oldest',
      id: 'Terlama'
    }
  },
  {
    key: 'id',
    value: 'id_ascending',
    label: {
      en: 'ID - Ascending',
      id: 'ID - Ascending'
    }
  },
  {
    key: 'id',
    value: 'id_descending',
    label: {
      en: 'ID - Descending',
      id: 'ID - Descending'
    }
  },
  {
    key: 'name',
    value: 'az',
    label: {
      en: 'Name: Ascending',
      id: 'Nama: Ascending'
    }
  },
  {
    key: 'name',
    value: 'za',
    label: {
      en: 'Name: Descending',
      id: 'Nama: Descending'
    }
  },
  {
    key: 'title',
    value: 'az',
    label: {
      en: 'Title: Ascending',
      id: 'Judul: Ascending'
    }
  },
  {
    key: 'title',
    value: 'za',
    label: {
      en: 'Title: Descending',
      id: 'Judul: Descending'
    }
  }
]

const sorter = (value, key, data, setData, language = 'id') => {
  let sorted = data

  if (value === 'az') {
    if(key === 'title'){
      sorted = data.slice().sort((a, b) => a[key][language].localeCompare(b[key][language]))
    } else {
      sorted = data.slice().sort((a, b) => a[key].localeCompare(b[key]))
    }
  }
  else if (value === 'za') {
    if(key === 'title'){
      sorted = data.slice().sort((a, b) => b[key][language].localeCompare(a[key][language]))
    } else {
      sorted = data.slice().sort((a, b) => b[key].localeCompare(a[key]))
    }
  }
  else if (value === 'id_ascending') {
    sorted = data.slice().sort((a, b) => a.id - b.id)
  }
  else if (value === 'id_descending') {
    sorted = data.slice().sort((a, b) => b.id - a.id)
  }

  else if (value === 'newest') {
    sorted = data.slice().sort((a, b) => {
      let key = 'published'

      if(a.published){
        key = 'published'
      } else if(a.created_at){
        key = 'created_at'
      } else if(a.start_date){
        key = 'start_date'
      }

      return new Date(b[key]) - new Date(a[key])
    })
  }
  else if (value === 'oldest') {
    sorted = data.slice().sort((a, b) => {
      let key = 'published'

      if(a.published){
        key = 'published'
      } else if(a.created_at){
        key = 'created_at'
      } else if(a.start_date){
        key = 'start_date'
      }

      return new Date(a[key]) - new Date(b[key])
    })
  }

  setData([])
  setTimeout(() => setData(sorted), 500)
}

const valueAdapter = {
  oldest: 'asc',
  newest: 'desc',
  az: 'asc',
  za: 'desc'
}

const reseter = (query) => {
  const cloned = {...query}
  if (cloned.date) delete cloned.date
  if (cloned.name) delete cloned.name
  if (cloned.title) delete cloned.title
  if (cloned.sort_by_title) delete cloned.sort_by_title

  return cloned
}

export { sorter, defaultSortOptions, valueAdapter, reseter }
